document.addEventListener("DOMContentLoaded", function () {
  const hideDisabledOptions = () => {
    document.querySelectorAll('.product-form__input label').forEach(label => {
      const inputId = label.getAttribute('for');
      const input = inputId ? document.getElementById(inputId) : null;

      // If label or input has class "disabled", hide them
      const isDisabled = label.classList.contains('disabled') || input?.classList.contains('disabled');

      if (isDisabled) {
        label.style.display = 'none';
        if (input) input.style.display = 'none';
      } else {
        label.style.display = 'inline-block';
        if (input) input.style.display = 'inline-block';
      }
    });
  };

  // Run immediately in case DOM is ready
  hideDisabledOptions();

  // Also run again whenever variants are updated
  const radios = document.querySelectorAll('variant-radios, variant-selects');
  radios.forEach(el => {
    el.addEventListener('change', hideDisabledOptions);
  });

  // Watch for any updates to the variant DOM
  const observer = new MutationObserver(hideDisabledOptions);
  observer.observe(document.querySelector('product-info'), { childList: true, subtree: true });
});